import React, { createContext, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import moment from "moment"
import { getSuperBillingTableData } from "../../actions/super"
import { getClientCompanies } from "../../actions/clients"
import { useDebounce } from "use-lodash-debounce"

const SuperTableContext = createContext()
export default SuperTableContext

export const SuperTableContainer = ({ children, ...props }) => {
  const dispatch = useDispatch()

  const [tableData, setTableData] = useState({})

  const billingAccess = useSelector(
    state => state.authentication.authenticatedUser.billing_access
  )

  const companyData = useSelector(state => state.clients.companiesList)

  const [tabValue, setTabValue] = useState(
    Boolean(billingAccess) ? "shoots" : "estimates"
  )

  //loading state for table overall
  const [loading, setLoading] = useState(false)
  //loading states for spinners on various tab buttons
  const [buttonLoadingStates, setButtonLoadingStates] = useState({
    shootsMarkPaidLoading: [],
    crewAdjustmentLoading: [],
    crewPayAllLoading: [],
    crewPayNowLoading: [],
    clientMarkPaidLoading: [],
    clientRequestLoading: [],
    soloInvoicePaidLoading: [],
  })

  const [searchValue, setSearchValue] = useState("")
  const debouncedSearchValue = useDebounce(searchValue, 300)

  const [clientCompanyValue, setClientCompanyValue] = useState("")

  const [paymentTermsFilter, setPaymentTermsFilter] = useState([])
  const [unpaid, setUnpaid] = useState(false)
  const [clietAccepted, setClientAccepted] = useState(false)

  const [dateInfo, setDateInfo] = useState({
    startDate: "",
    endDate: "",
    duration: "",
    value: "",
    wasIncreased: "",
    fullFetch: false,
  })

  // set the date range on first load to current month
  useEffect(() => {
    setDateInfo({
      startDate: moment()
        .startOf("month")
        .format(),
      endDate: moment()
        .endOf("month")
        .format(),
      duration: "month",
      value: 1,
    })
  }, [])

  // makes call to populate super billing table data
  useEffect(
    () => {
      setLoading(true)
      if (dateInfo && dateInfo.startDate && dateInfo.endDate) {
        let requestObject = {
          type: tabValue,
          endDate: dateInfo && dateInfo.endDate,
          startDate: dateInfo && dateInfo.startDate,
          searchKey: debouncedSearchValue,
          fullFetch: dateInfo && dateInfo.fullFetch,
        }
        // include filters in call on shoot tab only
        // do not send the filter object unless a company or payment term selected
        requestObject =
          paymentTermsFilter.length > 0 || clientCompanyValue || unpaid || clietAccepted
            ? {
              ...requestObject,
              filter: {
                payment_term: paymentTermsFilter,
                client_company: clientCompanyValue,
                is_unpaid: unpaid,
                client_accepted: clietAccepted ? 1 : 0
              },
            }
            : requestObject
        dispatch(getSuperBillingTableData(requestObject))
          .then(res => {
            setLoading(false)
            setTableData(res)
          })
          .catch(err => {
            console.log(err)
            setLoading(false)
            setTableData({})
          })
      }
    },
    [
      tabValue,
      debouncedSearchValue,
      paymentTermsFilter,
      clientCompanyValue,
      dateInfo,
      unpaid,
      clietAccepted
    ]
  )

  // populate list of client companies for search client companies autocomplete on Toolbar
  useEffect(() => {
    if (companyData.length === 0) {
      dispatch(getClientCompanies())
    }
  }, [])

  return (
    <SuperTableContext.Provider
      value={{
        tabValue,
        setTabValue,
        loading,
        setLoading,
        searchValue,
        setSearchValue,
        dateInfo,
        setDateInfo,
        tableData,
        setTableData,
        paymentTermsFilter,
        setPaymentTermsFilter,
        clientCompanyValue,
        setClientCompanyValue,
        buttonLoadingStates,
        setButtonLoadingStates,
        unpaid,
        setUnpaid,
        clietAccepted,
        setClientAccepted
      }}
    >
      {children}
    </SuperTableContext.Provider>
  )
}

SuperTableContainer.propTypes = {
  children: PropTypes.node,
}
